import { kea } from 'kea'
import PropTypes from 'prop-types'

import { removeLanguageUrlFromPath } from 'lib/utils/links'
import routeSelector from 'lib/selectors/route-selector'
import headerProps from 'lib/selectors/header-props'

export default kea({
  path: () => ['scenes', 'header', 'mainMenu'],

  connect: {
    props: [routeSelector, ['pathname']]
  },

  actions: () => ({
    openCountryModal: true,
    closeCountryModal: true,
    fixer: true,
    setCountries: countries => ({ countries }),
    showMenu: mainMenuId => ({ mainMenuId }),
    hideMenu: mainMenuId => ({ mainMenuId }),
    setActiveSubMenu: item => ({ item }),
    loadCountries: locale => ({ locale }),
    updateSelectedCountry: country => ({ country })
  }),

  defaults: {
    initialSubMenu: true,
    countryMenuOptions: state => headerProps(state).countryMenuOptions,
    selectedCountry: state => headerProps(state).countryMenuInformation.country,
    countryMenuInformation: state => headerProps(state).countryMenuInformation,
    mainMenuItems: state => headerProps(state).mainMenuItems
  },

  reducers: ({ actions }) => ({
    mainMenuItems: [
      [],
      PropTypes.array,
      {
        fixer: () => true
      }
    ],
    countryMenuInformation: [
      {},
      PropTypes.object,
      {
        fixer: () => true
      }
    ],
    countryMenuOptions: [
      {},
      PropTypes.object,
      {
        [actions.setCountries]: (state, { countries }) => ({ ...state, countries })
      }
    ],
    selectedCountry: [
      {},
      PropTypes.object,
      {
        [actions.updateSelectedCountry]: (_, { country }) => country
      }
    ],
    visibleMenus: [
      [],
      PropTypes.array,
      {
        [actions.showMenu]: (state, { mainMenuId }) => [...state, mainMenuId],
        [actions.hideMenu]: (state, { mainMenuId }) => state.filter(menuId => menuId !== mainMenuId),
        [actions.openCountryModal]: () => []
      }
    ],
    isCountryModalOpen: [
      false,
      PropTypes.bool,
      {
        [actions.openCountryModal]: () => true,
        [actions.closeCountryModal]: () => false
      }
    ],
    initialSubMenu: [
      false,
      PropTypes.bool,
      {
        [actions.setActiveSubMenu]: () => false
      }
    ],
    activeSubMenu: [
      null,
      PropTypes.string,
      {
        [actions.setActiveSubMenu]: (_, { item }) => item
      }
    ]
  }),

  selectors: ({ selectors }) => ({
    expandedMenuItem: [
      () => [selectors.activeSubMenu, selectors.initialSubMenu, selectors.pathname, selectors.mainMenuItems],
      (activeSubMenu, initialSubMenu, pathname, menuItems) => {
        let result = activeSubMenu
        if (initialSubMenu) {
          if (menuItems) {
            menuItems
              .filter(i => i)
              .forEach(menuItem => {
                const path = removeLanguageUrlFromPath(decodeURI(pathname))
                if (path.includes(menuItem.link) && menuItem.children) {
                  result = menuItem.name
                }
              })
          }
        }
        return result
      },
      PropTypes.string
    ]
  })
})
